import request from '@/utils/request'

const api = {
    Getcapacity: 'https://open.ys7.com/api/lapp/device/capacity', // 萤石云获取是否支持云台
    GetSFJInfoByCode: '/api/sfj/getSFJInfoByCode', // 优联施肥机参数获取
    SendMessageByCode: '/api/sfj/sendMessageByCode', // 设置优联施肥机通道模式
    ControlSFJByCode: '/api/sfj/controlSFJByCode', // 控制优联施肥机
    SetSFJParamByCode: '/api/sfj/setSFJParamByCode', // 设置优联施肥机参数
    GetSFJParamByCode: '/api/sfj/getSFJParamByCode', // 获取优联施肥机参数
    GetFarmMonitorStatus: '/api/farmMonitor/status', // 农场各类设备状态
    GetFarmMonitorDeviceDetail: '/api/farmMonitor/deviceDetail', // 农场异常设备详情
    Analyze4GOfflineReason: '/api/farmMonitor/analyze4GOfflineReason', // 分析4G设备离线原因
    RefreshFarmMonitorStatus: '/api/farmMonitor/refresh', // 重新查询农场各类设备状态
}

export function getcapacity(parameter) {
  return request({
    url: api.Getcapacity,
    method: 'get',
    params: parameter
  })
}

export function getSFJInfoByCode(parameter) {
  return request({
    url: api.GetSFJInfoByCode,
    method: 'get',
    params: parameter
  })
}

export function sendMessageByCode(parameter) {
  return request({
    url: api.SendMessageByCode,
    method: 'get',
    params: parameter
  })
}

export function controlSFJByCode(parameter) {
  return request({
    url: api.ControlSFJByCode,
    method: 'get',
    params: parameter
  })
}

export function setSFJParamByCode(parameter) {
  return request({
    url: api.SetSFJParamByCode,
    method: 'post',
    params: parameter
  })
}

export function getSFJParamByCode(parameter) {
  return request({
    url: api.GetSFJParamByCode,
    method: 'get',
    params: parameter
  })
}

export function getFarmMonitorStatus(parameter) {
  return request({
    url: api.GetFarmMonitorStatus,
    method: 'get',
    params: parameter
  })
}

export function getFarmMonitorDeviceDetail(parameter) {
  return request({
    url: api.GetFarmMonitorDeviceDetail,
    method: 'get',
    params: parameter
  })
}

export function analyze4GOfflineReason(parameter) {
  return request({
    url: api.Analyze4GOfflineReason,
    method: 'get',
    params: parameter
  })
}

export function refreshFarmMonitorStatus(parameter) {
  return request({
    url: api.RefreshFarmMonitorStatus,
    method: 'get',
    params: parameter
  })
}
